import { useCallback, useEffect, useRef, useState } from 'react'
import { useFocusRing } from '@react-aria/focus'
import { useButton } from '@react-aria/button'
import { EmblaCarouselType } from 'embla-carousel'
import { mergeProps } from '@react-aria/utils'

export const useNextButton = ({ emblaApi }: { emblaApi: EmblaCarouselType }) => {
  const buttonRef = useRef(null)
  const [isDisabled, setIsDisabled] = useState(false)

  const { isFocusVisible, focusProps } = useFocusRing()
  const { buttonProps, isPressed } = useButton(
    { elementType: 'button', onPress: () => emblaApi.scrollNext() },
    buttonRef,
  )

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setIsDisabled(!emblaApi.canScrollNext())
  }, [])

  useEffect(() => {
    onSelect(emblaApi)
    emblaApi.on('reInit', onSelect)
    emblaApi.on('select', onSelect)
  }, [emblaApi, onSelect])

  return {
    buttonRef,
    isDisabled,
    isFocusVisible,
    buttonProps: mergeProps(focusProps, buttonProps),
    isPressed,
  }
}
